import { Component, computed, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { NoodleService } from '../../../../services/noodle/noodle.service';
import { NoodleEnrichmentOptionsDto, NoodleQuestionDto, NoodleQuestionEnrichmentDto } from '../../../../common/general-types/noodle.dto';
import { MatSliderModule } from '@angular/material/slider';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'be-question-enrich',
  standalone: true,
  imports: [MatSliderModule, FormsModule],
  templateUrl: './question-enrich.component.html',
  styleUrl: './question-enrich.component.css'
})
export class QuestionEnrichComponent implements OnInit {

  @Input() question!: NoodleQuestionDto;
  @Output() enrichmentChange = new EventEmitter<string>();

  // collapsed = signal<boolean>(false);
  collapsed = signal<boolean>(true);
  enrichments = signal<NoodleEnrichmentOptionsDto[] | undefined>(undefined);
  selectedEnrichmentIndex = signal<number>(0);
  selectedEnrichment = computed(() => {
    const list = this.enrichments();
    const idx = this.selectedEnrichmentIndex();
    if (!list?.length || idx < 0 || idx >= list.length) return undefined;
    return list[idx];
  });

  /** Slider config: ticks = enrichments.length, one thumb */
  get enrichmentSliderMax(): number {
    const len = this.enrichments()?.length ?? 0;
    return Math.max(0, len - 1);
  }

  /** Services */
  private noodleService = inject(NoodleService);
  /** Services - END */

  ngOnInit(): void {
    if (this.question.generalisedId) {
      this.getQuestionEnrichment(this.question.generalisedId);
    } else {
      // this.collapsed.set(true);
    }
  }

  getQuestionEnrichment(generalisedId: string) {
    this.noodleService.getQuestionEnrichment(generalisedId).subscribe((enrichment: any) => {
      const list = enrichment.enrichments as NoodleEnrichmentOptionsDto[] | undefined;
      this.enrichments.set(list);

      let indexToUse = 0;
      const savedText = this.question.enrichments?.[0]?.text;
      if (list?.length && savedText) {
        const matchedIndex = list.findIndex(
          (e: NoodleEnrichmentOptionsDto) => e.enrichment_text === savedText
        );
        indexToUse = matchedIndex >= 0 ? matchedIndex : 0;
      }
      this.selectedEnrichmentIndex.set(indexToUse);
      // Do NOT emit on load
    });
  }

  onEnrichmentSliderChange(value: number | null): void {
    // console.log('onEnrichmentSliderChange(): ', value);
    const numericValue = typeof value === 'number' ? value : Number(value);
    this.selectedEnrichmentIndex.set(numericValue);
    this.question.enrichments = [{ text: this.selectedEnrichment()?.enrichment_text ?? '' }];
    const enrichment = this.selectedEnrichment();

    console.log('question changed: ', this.question);
    if (enrichment) {
      this.enrichmentChange.emit(enrichment.enrichment_text);
    }
  }

  getSelectedEnrichmentClass(enrichment: NoodleEnrichmentOptionsDto) {
    if (enrichment.enrichment_text === this.question.statement) {
      return 'text-green-500';
    } else if (enrichment.enrichment_text === this.question.selectedEnrichmentText) {
      return 'text-red-500';
    }
    else {
      return 'text-gray-500';
    }
  }
}
